import { Link, useOutletContext } from "react-router-dom";
import { BookOpen, Archive as ArchiveIcon, Megaphone } from "lucide-react";
import { Reveal, useSeo } from "@/components/site/Motion";

const Empty = ({ icon: Icon, eyebrow, title, text, cta, testid }) => (
  <Reveal data-testid={testid}>
    <p className="eyebrow mb-5">{eyebrow}</p>
    <div className="border border-dashed border-[#CFC6B8] bg-white/60 p-10 lg:p-16">
      <Icon className="w-10 h-10 text-[var(--emerald)] mb-8" strokeWidth={1.25} />
      <h1 className="font-display text-4xl sm:text-5xl leading-[1.05] mb-4" data-testid={`${testid}-title`}>{title}</h1>
      <p className="text-[var(--ink-muted)] text-lg max-w-xl">{text}</p>
      {cta}
    </div>
  </Reveal>
);

const SubmitCta = ({ slug }) => (
  <Link to={`/index.php/${slug}/about/submissions`} className="mt-8 inline-flex items-center h-12 px-6 rounded-full bg-[var(--emerald)] text-[var(--paper)] hover:bg-[var(--emerald-2)] transition-colors" data-testid="empty-submit-cta">Make a Submission</Link>
);

export const CurrentIssue = () => {
  const { journal } = useOutletContext();
  useSeo(`Current Issue · ${journal.title}`);
  return <Empty icon={BookOpen} eyebrow="Current issue" title="No Current Issue" text="This journal has not published any issues." cta={<SubmitCta slug={journal.slug} />} testid="current-issue" />;
};

export const Archive = () => {
  const { journal } = useOutletContext();
  useSeo(`Archives · ${journal.title}`);
  return <Empty icon={ArchiveIcon} eyebrow="Archives" title="No issues yet" text="No issues have been published." cta={<SubmitCta slug={journal.slug} />} testid="archive" />;
};

export const Announcements = () => {
  const { journal } = useOutletContext();
  useSeo(`Announcements · ${journal.title}`);
  return <Empty icon={Megaphone} eyebrow="Announcements" title="No announcements" text="No announcements have been published." testid="announcements" />;
};
